import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/rootState';
import DataTable from '../../../../Common/DataTable';
import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import { setLoader } from '../../../../redux/loaderSlice';
import { deleteBidStart, getBidsStart } from '../../redux/addCustomerSlice';
import { BidData } from './Utils/TypeBids';
import { defaultPageSize } from '../../../../utils/Constant';

export default function Bids() {
  const Navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBidId, setSelectedBidId] = useState('');

  const dispatch = useDispatch();
  const { customerId } = useParams();
  const { bidsList, isLoading, totalEntries } = useSelector((state: RootState) => state.addCustomerReducer);

  const handleData = () => {
    const params = {
      customerId: customerId || '',
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(getBidsStart(params));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const handleDelete = (id: string) => {
    setShowDeleteModal(true);
    setSelectedBidId(id);
  };

  const handelDeleteModal = () => {
    const paramData = {
      bidId: selectedBidId,
      customerId: customerId || '',
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(deleteBidStart(paramData));
    setShowDeleteModal(false);
  };

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Actions' },
      { key: 'BidId', label: 'Bid ID' },
      { key: 'JobId', label: 'Job #' },
      { key: 'BidName', label: 'Bid Name' },
      { key: 'BidCreationDate', label: 'Bid Date' },
      { key: 'SiteName', label: 'Job Site' },
      { key: 'City', label: 'City' },
    ],
    [],
  );

  const data: BidData[] = useMemo(() => bidsList.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      id: item?.BidId,
      action: 'edit&delete',
      BidId: item?.BidId,
      JobId: item?.JobId,
      BidName: item?.BidName,
      BidCreationDate: item?.BidCreationDate,
      SiteName: item?.SiteName,
      City: item?.City,
    };
    return transformedDataItem;
  }), [bidsList]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleEdit = (id: string) => {
    Navigate(`/jobs/bid-worksheet/${id}`);
  };

  return (
    <div id="bids-tab-content">
      <DataTable<BidData>
        data={data}
        columns={columns}
        totalRecords={totalEntries}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleData={handleData}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      />
    </div>
  );
}
